import React from 'react';
export function PainSection() {
  return <section className="py-20 bg-white" data-id="element-172">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-173">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-charcoal mb-8 text-center" data-id="element-174">
          ¿Te suena esto?
        </h2>

        <div className="space-y-6 text-lg text-gray-700 leading-relaxed" data-id="element-175">
          <p className="font-medium text-brand-teal text-xl" data-id="element-176">
            Son las 11 de la noche.
          </p>

          <p data-id="element-177">
            Mañana tenés una paciente con resistencia a la insulina que no baja
            de peso aunque dice que come bien. Un señor de 67 años con
            hipertensión que come todo con sal. Y una primera consulta de una
            chica de 22 años que le dijeron que tiene SII y no sabe qué comer.
          </p>

          <p data-id="element-178">
            Abrís Google. Buscás en grupos de nutricionistas de WhatsApp.
            Encontrás un protocolo de un curso que hiciste hace dos años y que
            no llegaste a terminar. Una hora después tenés algo armado.
          </p>

          <p className="font-medium" data-id="element-179">
            No es lo que querías. Pero es lo que hay.
          </p>

          <p data-id="element-180">Y lo peor no es el tiempo perdido.</p>

          <div className="bg-red-50 border-l-4 border-red-400 p-6 rounded-r-lg mt-8" data-id="element-181">
            <p className="text-xl font-medium text-red-900 italic" data-id="element-182">
              "Lo peor es llegar a esa consulta sin la certeza de que lo que vas
              a hacer es exactamente lo correcto para ese paciente en ese
              momento."
            </p>
          </div>
        </div>
      </div>
    </section>;
}